<template>
  <div class="relative flex items-center">
    <div v-if="$slots.icon" class="absolute left-4 z-10 w-6 text-blue-800">
      <slot name="icon" />
    </div>
    <Multiselect
      v-bind="{ ...$attrs }"
      :model-value="modelValue"
      :no-results-text="$t('no_results')"
      :object="true"
      :searchable="false"
      :close-on-select="false"
      :hide-selected="false"
      value-prop="slug"
      :classes="{
        container: `multiselect-container lg:max-w-[16rem] relative bg-[#F0FAFF] transition hover:bg-bg-blue-50 w-full ${
          $slots.icon ? 'pl-8' : 'pl-1.5'
        } pr-1 py-1 flex items-center justify-end box-border cursor-pointer rounded-sm text-base outline-none`,
        search: 'bg-transparent outline-none',
        placeholder:
          'flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 text-black rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5',
        dropdown:
          'multiselect-dropdown !bg-[#F0FAFF] !border-l-0 !max-h-[14.5rem]  !border-r-0 !border-b-0 !border-t-[3px] !border-white',
        options: 'flex flex-col py-1.5 m-0 list-none',
        option: 'flex items-start px-5 py-1.5',
      }"
      @update:model-value="updateValue"
      @open="opened = true"
      @close="opened = false"
    >
      <template #caret>
        <CaretRightIcon
          class="mr-4 w-2 shrink-0 rotate-90 text-blue-800 transition-transform"
          :class="{ '!-rotate-90': opened }"
        />
      </template>
      <template #singlelabel="{ value }">
        <div class="multiselect-single-label">
          <span class="max-h-full">{{ value.title }}</span>
        </div>
      </template>
      <template #multiplelabel="{ values }">
        <div class="multiselect-multiple-label">
          {{ values.length }} {{ $t('selected') }}
        </div>
      </template>
      <template #option="data">
        <div
          class="mr-2.5 mt-[0.3em] flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border-2 border-blue-800 bg-white p-0.5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12.023 9.688"
            class="hidden h-3 w-3 text-blue-800"
          >
            <path
              id="Path_556"
              data-name="Path 556"
              d="M-23312.98-6465.871l2.719,3.312,3.762-4.221,2.723-3.055"
              transform="translate(23314.389 6471.247)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="3"
            />
          </svg>
        </div>
        <span class="pr-2">
          {{ data.option.title || data.option.label }}
        </span>
      </template>
    </Multiselect>
  </div>
</template>

<script setup>
import '@vueform/multiselect/themes/default.css'

defineProps({
  modelValue: {
    type: [String, Number, Array, Object],
    default: null,
  },
})

const opened = ref(false)

const emit = defineEmits(['update:modelValue'])

const updateValue = (event) => {
  emit('update:modelValue', event)
}
</script>

<style>
.multiselect-container .is-selected svg {
  @apply inline-block;
}

.multiselect-caret,
.multiselect-clear-icon {
  @apply bg-blue-800;
}
</style>
